import React,{useState,useEffect} from 'react';
import axios from 'axios';
import Check_o from './img/gg_check-o.png';
import Check_e from './img/ic_sharp-error-outline.png';


/* axios instance 생성 */
export const instance = axios.create({
	baseURL: 'https://abys-service.co.kr:3001',
    headers : {'impact_api_key': 'J56z;[qW;1dXwEA8xB6Qmj[:Cp8/ISmE'}
})


export const SERVER_IP = 'https://abys-service.co.kr:3001';


export function axiosDefault(){
    const data = instance.post(`https://abys-service.co.kr:3001/car/brand`);
    return data;
}

export function axiosParams(obj){
    const data = instance.post(`https://abys-service.co.kr:3001/car/list`,obj);
    return data;
}


export function comma(str) {
    str = String(str);
    return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
}
export function uncomma(str) {
    str = String(str);
    return str.replace(/[^\d]+/g, '');
}

//날짜 format yyyy-mm-dd
export function formatDate(date) { 
    let month = '' + (date.getMonth() + 1), day = '' + date.getDate(), year = date.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
}

export function formatDate2(param){
    const expires = new Date(param)
    const fullYear = expires.getFullYear();
    const month = expires.getMonth() + 1;
    const date = expires.getDate();

    return fullYear + '년 ' + month + '월 ' + date + '일 ';
}

export function formatDate3(param){
    const expires = new Date(param)
    const fullYear = expires.getFullYear();
    const month = expires.getMonth() + 1;
    const date = expires.getDate();
    let day = expires.getDay();
    if (day === 0) {
        day = '일요일';
    } else if (day === 1) {
        day = '월요일';
    } else if (day === 2) {
        day = '화요일';
    } else if (day === 3) {
        day = '수요일';
    } else if (day === 4) {
        day = '목요일';
    } else if (day === 5) {
        day = '금요일';
    } else {
        day = '토요일';
    }
    return fullYear + '년 ' + month + '월 ' + date + '일 ' + day;
}


//날짜 핸드폰,fax 하이푼
export function phoneFormat(target){

    const phone = target.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,"$1-$2-$3").replace("--", "-");

    return phone;
}

//사업자 번호 하이푼

export function biznumFormat(companyNum){

    companyNum = companyNum.replace(/[^0-9]/g, '');
    var tempNum = '';   

    if(companyNum.length < 4){
      return companyNum;
    }
    else if(companyNum.length < 6){
      tempNum += companyNum.substr(0,3);
      tempNum += '-';
      tempNum += companyNum.substr(3,2);
      return tempNum;
    }
    else if(companyNum.length < 11){
      tempNum += companyNum.substr(0,3);
      tempNum += '-';
      tempNum += companyNum.substr(3,2);
      tempNum += '-';
      tempNum += companyNum.substr(5);
      return tempNum;
    }
    else{        
      tempNum += companyNum.substr(0,3);
      tempNum += '-';
      tempNum += companyNum.substr(3,2);
      tempNum += '-';
      tempNum += companyNum.substr(5);
      return tempNum;
    }


}


// select 컴포넌트
export function Select({name,onChange,optionArr}){
    return (
        <select className="form-control" name={name} onChange={onChange}>
            <option value="">-</option>
            {optionArr.map((v)=><option key={v} value={v}>{v}</option>)}
        </select>
    )

}


export function returnDate(date_str)
{
    var yyyyMMdd = String(date_str);
    var sYear = yyyyMMdd.substring(0,4);
    var sMonth = yyyyMMdd.substring(5,7);
    var sDate = yyyyMMdd.substring(8,10);

    //alert("sYear :"+sYear +"   sMonth :"+sMonth + "   sDate :"+sDate);
    return new Date(Number(sYear), Number(sMonth)-1, Number(sDate));
}

export function currentDate(){
    let date = new Date();
    let year = date.getFullYear();
    
    let month = (1 + date.getMonth());
        month = month >= 10 ? month : '0' + month;

    let day = date.getDate();
        day = day >= 10 ? day : '0' + day;

    return year + '-' + month + '-' + day;
}

export function currentNoHyDate(){
    let date = new Date();
    let year = date.getFullYear();
    
    let month = (1 + date.getMonth());
        month = month >= 10 ? month : '0' + month;

    let day = date.getDate();
        day = day >= 10 ? day : '0' + day;

    return year + month  + day;
}

export function currentDate_j(){
    let date = new Date();
    let year = date.getFullYear();
    
    let month = (1 + date.getMonth());
        month = month >= 10 ? month : '0' + month;


    return year + '.' + month ;
}


//insert용
export function AxiosInsert(endPath,endPoint,param){
 
    axios.post('https://abys-service.co.kr:3001/'+endPath+'/'+endPoint,param)
    .then(function (response) {
        // handle success

    })
    .catch(function (error) {
        // handle error
        console.log(error);
    })

}

//return 용
//일반 AXIOS
export function AxiosLoad(endPath,endPoint){
    const [data, setData] = useState([]);
    
    useEffect(() => {    
        axios.post('https://abys-service.co.kr:3001/'+endPath+'/'+endPoint)
        .then(function (response) {
            // handle success
            
            setData(response.data)
            
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        
    }, []);
    
    return data;
}

//파라미터 존재하는 AXIOS

export function AxiosParamLoad(endPath,endPoint,param){

    
    const [data, setData] = useState([]);
    
    useEffect(() => {
        
        axios.post('https://abys-service.co.kr:3001/'+endPath+'/'+endPoint,param)
        .then(function (response) {
            // handle success
            
            setData(response.data)
            
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        
    }, [data]);
    
    return data;
}

export function AxiosParamLoadStatic(endPath,endPoint,param){

    
    const [data, setData] = useState([]);
    
    useEffect(() => {
        
        axios.post('https://abys-service.co.kr:3001/'+endPath+'/'+endPoint,param)
        .then(function (response) {
            // handle success
            
            setData(response.data)
            
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        
    }, []);
    
    return data;
}


export function ContractCheckAlert({history,pro,inputs}){
    const fixed = {
        position:'fixed',
        top:'50%',
        left:'50%',
        transform:'translate(-50%,-50%)',
        background:'#fff',
        borderRadius:'5px',
        zIndex:'2',
        width:'350px'
    }
    const bg = {
        background:'rgba(0,0,0,0.4)',
        width:'100%',
        height:'100vh',
        position:'fixed',
        top:'0',
        zIndex:'1'
    }
    const btnWdith = {
        width:'150px',
        background:'#06f'
    }
    const imgWidth = {
        width:'85px'
    }

    const goPage = () => {
        history.push('/repFindShop?num='+inputs);
    }
    return (
        <>
        <div style={bg}></div>
        <div className="text-center p-4" style={fixed}>
            <img src={Check_o} style={imgWidth} className="mb-5 mt-3"/>
            <h4 className="font-weight-bold">정상적으로 인증되었습니다. 감사합니다.</h4>

            {
                pro == 1 && <h4 className="font-weight-bold mt-5">프로모션 : 프로모션 상품</h4>
            }
            
            <h5 className="font-weight-bold mb-5">※ 현대캐피탈 할부 취소시, 예약이 취소 될 수 있습니다.</h5>
            <span className="btn btn-primary pt-3 pb-3" style={btnWdith} onClick={goPage}>확인</span>
        </div>
        </>
    )
}

export function CustomAlert({history,pro,r_id,co_discount,inputs,promotionText}){
    const fixed = {
        position:'fixed',
        top:'50%',
        left:'50%',
        transform:'translate(-50%,-50%)',
        background:'#fff',
        borderRadius:'5px',
        zIndex:'2',
        width:'350px'
    }
    const bg = {
        background:'rgba(0,0,0,0.4)',
        width:'100%',
        height:'100vh',
        position:'fixed',
        top:'0',
        zIndex:'1'
    }
    const btnWdith = {
        width:'150px',
        background:'#06f'
    }
    const imgWidth = {
        width:'85px'
    }

    const goPage = () => {
        let obj = {
            contract_num:inputs
        }
        let valueObj = {
            obj:obj,
            whereField:'r_id',
            whereValue:r_id
        }
        const fetchData = async () => {
            instance.post('/reserve/update',valueObj).then(function(res){
                //history.push('/reserve_detail?r_id='+r_id+'&date='+date+'&si_id='+si_id);
                history.goBack();
                
            });
            
        };
    
        fetchData();
        
    }
    return (
        <>
        <div style={bg}></div>
        <div className="text-center p-4" style={fixed}>
            <img src={Check_o} style={imgWidth} className="mb-5 mt-3"/>
            <h4 className="font-weight-bold">정상적으로 인증되었습니다. 감사합니다.</h4>

            {
                pro == 1 && 
                <>
                <h4 className="font-weight-bold mt-5">프로모션 : 프로모션 상품</h4>
                <h4 className="font-weight-bold mt-3 mb-4">할인금액 : {comma(co_discount)} 원</h4>
                </>
            }
            
            <h5 className="font-weight-bold mb-5">※ 현대캐피탈 할부 취소시, 예약이 취소 될 수 있습니다.</h5>
            <span className="btn btn-primary pt-3 pb-3" style={btnWdith} onClick={goPage}>확인</span>
        </div>
        </>
    )
}




export function CustomAlert2({popup,setPopup,promotionText}){
    const fixed = {
        position:'fixed',
        top:'50%',
        left:'50%',
        transform:'translate(-50%,-50%)',
        background:'#fff',
        borderRadius:'5px',
        zIndex:'2',
        width:'350px'
    }
    const bg = {
        background:'rgba(0,0,0,0.4)',
        width:'100%',
        height:'100vh',
        position:'fixed',
        top:'0',
        zIndex:'1'
    }
    const btnWdith = {
        width:'150px',
        background:'#06f'
    }
    const imgWidth = {
        width:'85px'
    }

    const onClick = () => {
        setPopup({
            ...popup,
            no:false
        })
    }

    return (
        <>
        <div style={bg}></div>
        <div className="text-center p-4" style={fixed}>
            <img src={Check_e} style={imgWidth} className="mb-5 mt-3"/>
            {
                promotionText === '계약번호' ?
                <>
                <h4 className="font-weight-bold">현대캐피탈 계약번호가 아닙니다.</h4>
                </>
                :
                <h4 className="font-weight-bold">{promotionText}가 아닙니다.</h4>
            }
            <h4 className="font-weight-bold mb-5">다시 확인해주세요.</h4>
            {
                promotionText === '계약번호' &&
                <>
                <h5 className="font-weight-bold">※ 현대캐피탈 할부 미확정시, 인증이 되지 않습니다.</h5>
                <h5 className="font-weight-bold mb-5">할부 확정 후 +1 영업일에 재인증 해주세요.</h5>
                </>
            }
            

            <h4 className="font-weight-bold mb-5">고객문의 : 1544-2160</h4>
            <span className="btn btn-primary pt-3 pb-3" style={btnWdith} onClick={onClick}>확인</span>
        </div>
        </>
    )
}


export function CustomAlert3({popup,setPopup,promotionText}){
    const fixed = {
        position:'fixed',
        top:'50%',
        left:'50%',
        transform:'translate(-50%,-50%)',
        background:'#fff',
        borderRadius:'5px',
        zIndex:'2',
        width:'350px'
    }
    const bg = {
        background:'rgba(0,0,0,0.4)',
        width:'100%',
        height:'100vh',
        position:'fixed',
        top:'0',
        zIndex:'1'
    }
    const btnWdith = {
        width:'150px',
        background:'#06f'
    }
    const imgWidth = {
        width:'85px'
    }

    const onClick = () => {
        setPopup({
            ...popup,
            ex:false
        })
    }

    return (
        <>
        <div style={bg}></div>
        <div className="text-center p-4" style={fixed}>
            <img src={Check_e} style={imgWidth} className="mb-5 mt-3"/>
            <h4 className="font-weight-bold">이미 인증된 {promotionText}입니다.</h4>
            <h4 className="font-weight-bold mb-5">다른 {promotionText}를 입력해주세요.</h4>

            {
                promotionText === '계약번호' &&
                <>
                <h5 className="font-weight-bold">※ 현대캐피탈 할부 미확정시, 인증이 되지 않습니다.</h5>
                <h5 className="font-weight-bold mb-5">할부 확정 후 +1 영업일에 재인증 해주세요.</h5>
                </>
            }

            <h4 className="font-weight-bold mb-5">고객문의 : 1544-2160</h4>
            <span className="btn btn-primary pt-3 pb-3" style={btnWdith} onClick={onClick}>확인</span>
        </div>
        </>
    )
}

/*
export function setCookie(name, value, exp) {
    var date = new Date();
    date.setTime(date.getTime() + exp*24*60*60*1000);
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
};

export function getCookie(name) {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value? value[2] : null;
};
*/

//일치하지 않는 alert창
export function CustomAlert_x({popup,setPopup,promotionText}){
    const fixed = {
        position:'fixed',
        top:'50%',
        left:'50%',
        transform:'translate(-50%,-50%)',
        background:'#fff',
        borderRadius:'5px',
        zIndex:'2',
        width:'350px'
    }
    const bg = {
        background:'rgba(0,0,0,0.4)',
        width:'100%',
        height:'100vh',
        position:'fixed',
        top:'0',
        zIndex:'1'
    }
    const btnWdith = {
        width:'150px',
        background:'#06f'
    }
    const imgWidth = {
        width:'85px'
    }

    const onClick = () => {
        setPopup({
            ...popup,
            format:false
        })
    }

    return (
        <>
        <div style={bg}></div>
        <div className="text-center p-4" style={fixed}>
            <img src={Check_e} style={imgWidth} className="mb-5 mt-3"/>
            <h4 className="font-weight-bold">형식에 맞는 {promotionText}를 입력해주세요.</h4>


            <h5 className="font-weight-bold">※ 영문, 숫자로 이루어진 13자리를 입력해주세요.</h5>

            <h4 className="font-weight-bold mt-3 mb-5">고객문의 : 1544-2160</h4>
            <span className="btn btn-primary pt-3 pb-3" style={btnWdith} onClick={onClick}>확인</span>
        </div>
        </>
    )
}


export const resetSession = () => {
    window.sessionStorage.removeItem('page');
    window.sessionStorage.removeItem('optionValue')
    window.sessionStorage.removeItem('change_date');
    window.sessionStorage.removeItem('change_date_now');
    window.sessionStorage.removeItem('date_active');
    window.sessionStorage.removeItem('startDate');
    window.sessionStorage.removeItem('endDate');
}

export const dateReset = () => {
    window.sessionStorage.removeItem('startDate');
    window.sessionStorage.removeItem('endDate');
}
